import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { css } from 'styled-components';

const uriCache = new Map<IconDefinition, string>();

function faIconUri(icon: IconDefinition): string {
    let uri = uriCache.get(icon);
    if (!uri) {
        const [w, h, , , d] = icon.icon;
        uri = `url("data:image/svg+xml,${encodeURIComponent(
            `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${w} ${h}'><path d='${d}'/></svg>`,
        )}")`;
        uriCache.set(icon, uri);
    }
    return uri;
}

export function faIconBefore(icon: IconDefinition, color: string) {
    const uri = faIconUri(icon);

    return css`
    &::before {
      content: "";
      display: inline-block;
      width: 1em;
      height: 1em;
      margin-right: 0.4em;
      vertical-align: -0.125em;
      background-color: ${color};
      mask-image: ${uri};
      mask-size: contain;
      mask-repeat: no-repeat;
      -webkit-mask-image: ${uri};
      -webkit-mask-size: contain;
      -webkit-mask-repeat: no-repeat;
    }
  `;
}
